import { Button, Card, Checkbox, Form, Input, message, Spin } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import App from './LayoutMobile'
import { Config } from './Common/Config';
import { EyeInvisibleOutlined, EyeTwoTone, EditOutlined } from "@ant-design/icons";
import axios from 'axios';

const PaymentSettings = () => {
    const [form] = Form.useForm();
    const [loader, setloader] = useState(false)
    const [editAction, seteditAction] = useState(false)
    const [selectedKeyId, setselectedKeyId] = useState(null)
    const [isSandbox, setIsSandbox] = useState(null); // Track sandbox mode
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [messageApi, contextHolder] = message.useMessage();

    useEffect(() => {
        fetchKeys(isSandbox);
    }, [isSandbox]);

    const fetchKeys = async (mode) => {
        setloader(true);
        try {
            let url = `${Config.url}payment-keys`;
            if (mode === 0 || mode === 1) {
                url += `?is_livemode=${mode}`;
            }
            const response = await axios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            setloader(false);
            const data = response?.data?.data?.[0];
            if (data) {
                setselectedKeyId(data.id);
                form.setFieldsValue({
                    isSandbox: data.is_livemode === "0",
                    public_key: data.public_key,
                    secret_key: data.secret_key,
                });
            } else {
                form.resetFields();
                setselectedKeyId(null);
            }
        } catch (error) {
            setloader(false);
            messageApi.error(error.response?.data?.message || error.message || "Something went wrong");
        }
    };
    const onFinish = async (values, id) => {
        // console.log('values :::', values, id,editAction)
        if (!values.public_key || !values.secret_key ) {
            return messageApi.error({
                type: 'error',
                content: 'Please enter both public and secret keys',
            });
        }
        // 'https://api.ldcbe.webdezign.uk/api/admin/v1/payment-keys/7'
        // return
        try {
            setIsSubmitting(true);
            // const response = await axios.post(`https://api.ldcbe.webdezign.uk/api/v1/login`, {
            let parayload = {}
            if(editAction){
                parayload = {
                    is_livemode: values.isSandbox ? 0 : 1,
                    secret_key: values.secret_key,
                    public_key: values.public_key
                }
            }else{
                parayload = {
                    is_livemode: values.isSandbox ? 0 : 1,
                }
            }

            const response = await axios.put(`${Config.url}payment-keys/${id}`, parayload, 
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            // console.log('Login Successful:', response);
            messageApi.success({
                type: 'succes',
                content: 'Payment Method Updated successfully',
            });
            setIsSubmitting(false);



        } catch (error) {
            console.log('Login Failed:', error.response?.data || error?.message);
            messageApi.error({
                type: 'error',
                content: error.response?.data?.message || error.message || 'Something Went wrong',
            });
            setIsSubmitting(false);
        }

    };
    // const handleOnchange = (e) => {
    //     if (e.target.checked) {
    //         // console.log('paymentDataById :::', paymentDataById['0'])
    //         setselectedKeyId(paymentDataById['0'].id)
    //         form.setFieldsValue({
    //             "public_key": paymentDataById['0'].public_key,
    //             "secret_key": paymentDataById['0'].secret_key,
    //         });
    //     } else {
    //         console.log('paymentDataById :::', paymentDataById['1'])
    //         setselectedKeyId(paymentDataById['1']?.id)
    //         form.setFieldsValue({
    //             "public_key": paymentDataById['1'].public_key,
    //             "secret_key": paymentDataById['1'].secret_key,
    //         });
    //     }
    // }
     const handleOnchange = (e) => {
        console.log('Checkbox checked:', e.target.checked);
        setIsSandbox(e.target.checked ? 0 : 1); // Update state based on checkbox
        // seteditAction(false);
    };
    return (
        <App>
            {contextHolder}
            {loader && <div style={{ textAlign: 'center', marginTop: 20 }}><Spin className="custom-spinner"/></div>}
            {!loader && <div style={{ display: 'flex', justifyContent: 'center' }}>
                <div
                    style={{ width: 460, height: 300, padding: '20px', borderRadius: '8px', boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)" }}
                >
                    <div style={{ height: 50, backgroundColor: '#008385', borderTopLeftRadius: '8px', borderTopRightRadius: '8px', color: '#fff', fontSize: 25, textAlign: 'center', padding: '7px' }} >
                        Payment Setting
                    </div>
                    <div style={{ margin: 'auto', width: 400, marginTop: 10 }}>
                        <Form form={form} autoComplete="off" onFinish={(values) => onFinish(values, selectedKeyId)}>
                            <Form.Item name="isSandbox" valuePropName="checked" style={{ width: '378px', height: 10, marginLeft: 10 }}>
                                <Checkbox
                                    checked={isSandbox}
                                    onChange={handleOnchange}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                    }}
                                >
                                    <span>
                                        Sandbox Mode
                                    </span>
                                </Checkbox>
                            </Form.Item>
                            <Form.Item name="public_key" rules={[{ required: false, message: "Rule name is required." }]}>
                                <Input disabled={editAction ? false : true} placeholder='Stripe Publishable Key: abcxyz' style={{ width: '378px', height: 40 }} suffix={<EditOutlined style={{ color: '#008385' }} onClick={() => {
                                    seteditAction(true)
                                    form.setFieldsValue({
                                        "public_key": '',
                                        "secret_key": '',
                                    });
                                }} />} />
                            </Form.Item>
                            <Form.Item name="secret_key" rules={[{ required: false, message: "Min. period (hrs) is required." }]} >
                                <Input disabled={editAction ? false : true} placeholder='Stripe Secret Key: xyzabc' style={{ width: '378px', height: 40 }} suffix={<EditOutlined style={{ color: '#008385' }} onClick={() => {
                                    seteditAction(true)
                                    form.setFieldsValue({
                                        "public_key": '',
                                        "secret_key": '',
                                    });
                                }} />} />
                            </Form.Item>
                            {<>  <Button className="add-generic-btn" style={{ width: 174, height: 40, backgroundColor: '#008385', color: '#fff', marginRight: 10 }} onClick={() => {
                                seteditAction(false)
                            }}>
                                Cancel
                            </Button>
                                <Button
                                    style={{
                                        width: 174,
                                        height: 40,
                                        backgroundColor: isSubmitting ? '#80bebe' : '#008385',
                                        borderColor: isSubmitting ? '#80bebe' : '#008385',
                                        color: '#fff',
                                        cursor: isSubmitting ? 'not-allowed' : 'pointer',
                                    }}
                                    htmlType="submit"
                                    loading={isSubmitting}
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? 'Saving...' : 'Save'}
                                </Button></>}

                        </Form>
                    </div>
                </div>
            </div>}
        </App>
    )
}

export default PaymentSettings